import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { CampanhaItem } from "./CampanhaItem";
import { OmniContent } from "../OmniContent/default";
import { useMobileDetect } from "../../hooks";

export const CampanhasLines = ({ campanhas, creator }) => {
    const isMobile = useMobileDetect();
    
    const renderCampanhaItem = (campanha, index) => (
        <CampanhaItem key={index} campanha={campanha} creator={creator} />
    );

    const titles = ["Campanha", "Cliente", "Progresso", "", ""];
    const showTitles = !isMobile && campanhas?.length > 0;

    return (
        <Container maxWidth="xl" disableGutters sx={{ m: 1 }}>
            {showTitles && (
                <Box className="headerCampainList">
                    {titles.map((title, index) => (
                        <Box sx={{ flexBasis: "100%" }} key={index}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "var(--primary-dark-color)",
                                    fontWeight: "700",
                                    textAlign: "center",
                                }}
                            >
                                {title}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            )}
            {campanhas?.length ? (
                [...campanhas].sort((a, b) => b.id - a.id).map(renderCampanhaItem)
            ) : (
                <OmniContent />
            )}
        </Container>
    );
};
